import type { FieldValidator } from '@payaca/types/fieldValidationTypes';
import { getRegexMatchFieldValidator } from './fieldValidationHelper';

export const minimumLengthValidationMessage =
  'Password must be at least 12 characters';
export const mustContainLetterValidationMessage =
  'Password must contain 1 letter';
export const mustContainNumberValidationMessage =
  'Password must contain 1 number';

export const minimumLengthFieldValidator: FieldValidator =
  getRegexMatchFieldValidator(/^.{12,}$/, {
    customErrorMessage: minimumLengthValidationMessage,
  });
export const mustContainLetterFieldValidator: FieldValidator =
  getRegexMatchFieldValidator(/[a-zA-Z]/, {
    customErrorMessage: mustContainLetterValidationMessage,
  });
export const mustContainNumberFieldValidator: FieldValidator =
  getRegexMatchFieldValidator(/\d/, {
    customErrorMessage: mustContainNumberValidationMessage,
  });
